jQuery(document).ready(function($) {
		  
	// ##############################################
	// ############## Header-Functions ##############
	// ##############################################
		
	// Sticky-Header und responsive Nav
	if ($(window).width() < 1200) {
		var $offsetStickyNav = 84;
		var $offsetStickyNavScrolled = 84;
	} else {
		var $offsetStickyNav = 169;
		var $offsetStickyNavScrolled = 84;
	}
  if ($('.page-submenu').length) {
    $offsetStickyNav = $offsetStickyNav + $('.page-submenu').outerHeight();
    $offsetStickyNavScrolled = $offsetStickyNavScrolled + $('.page-submenu').outerHeight();
  }
	  
	$(window).resize(function() {
		if ($(window).width() < 1200) {
			$offsetStickyNav = 84;
  		$offsetStickyNavScrolled = 84;
	    $('.nav-collapse').collapse('hide');
      $('.primary-nav .dropdown').removeClass('show');
      $('.primary-nav .dropdown').find('.dropdown-menu').removeClass('show');
      //$('.primary-nav .dropdown').dropdown('toggle')
		} else {
			$offsetStickyNav = 169;
  		$offsetStickyNavScrolled = 84;
			$('body').removeClass('pushy-open-left');
		}
    if ($('.page-submenu').length) {
      $offsetStickyNav = $offsetStickyNav + $('.page-submenu').outerHeight();
      $offsetStickyNavScrolled = $offsetStickyNavScrolled + $('.page-submenu').outerHeight();
    }
	});
    
	(function () {
      var footer = $('body footer.page-footer').get(0);
    	var top;
    	var scrollPos;
        var vh = $(window).outerHeight();
        $(window).resize(function () {
            vh = $(window).outerHeight();
        });
        var scrollToTop =  $('.scrollToTop');
    	
    	var relative = false;
    	var visible = false;
    	var stickyNav = false;

    	
        $(window).scroll(function () {
            scrollPos = $(window).scrollTop();
            
            top = footer.getBoundingClientRect().top;
            if ((top < vh) != relative) {
                relative = top < vh;
                scrollToTop.toggleClass('relative', relative);
            }
            
            if (visible != (scrollPos > 250)) {
                visible = scrollPos > 250;
                scrollToTop.fadeToggle(visible);
            }
            
            if (stickyNav != (scrollPos >= $offsetStickyNav)) {
                stickyNav = scrollPos >= $offsetStickyNav;
                $('body').toggleClass('sticky-nav', stickyNav);
            }
            
        });  	
	}())
  
  
  
  
  // ##############################################
  // ################ Desktop-Nav #################
  // ##############################################

  // Add slideDown animation to Bootstrap dropdown when expanding.
  $('.primary-nav .dropdown, .secondary-nav .dropdown').on('show.bs.dropdown', function() {
    $('.nav-collapse').collapse('hide');
    $(this).find('.dropdown-menu').first().stop(true, true);
    $(this).find('.dropdown-menu > .dropdown-menu-inner').slideDown('400');
  });

  // Add slideUp animation to Bootstrap dropdown when collapsing.
  $('.primary-nav .dropdown, .secondary-nav .dropdown').on('hide.bs.dropdown', function() {
    $(this).find('.dropdown-menu').first().stop(true, true);
    $(this).find('.dropdown-menu > .dropdown-menu-inner').slideUp('400');
  });
  
  
  
  // ##############################################
  // ################# Pushy-Nav ##################
  // ##############################################
  
  $('.menu-btn, .site-overlay').click(function(){
    if (!$('body').hasClass('pushy-open-left')) {
  		$('.pushy').animate({scrollTop : 0}, 800);
  		return false;
    } 
  });
  
	$('.pushy .pushy-content ul').find('.pushy-submenu.active').removeClass('pushy-submenu-closed').addClass('pushy-submenu-open');
  
  
	// ##############################################
	// ############ Subnavi, Anchor-Link ############
	// ##############################################  

  // Stört Accordion und Slider???
  $('a[href*="#c"]:not([href="#"]), a.anchor-link').click(function(event) {
    if (location.hostname == this.hostname) {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && !$(this).hasClass('giz-fancybox-inline')) {
        event.preventDefault();
        var $navOffset = $offsetStickyNav;
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        var $targetTop = $(this.hash).offset().top;
        if ($targetTop >= $offsetStickyNav) {
          $navOffset = $offsetStickyNavScrolled;
        }
        if ($(this).parents('#submenu')) {
          $(this).parents('#submenu').collapse('hide')
        }
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - $navOffset
          }, 500);
          //console.log('Scrollt wegen ANKER!');
          return false;
        }
      } else {
        // Bei anderem Pfad weiter...
        return;
      } 
    }
  });

  // ##############################################
	// ################# Accordion ##################
	// ##############################################

	$('.accordion .collapse').on('shown.bs.collapse', function (e) {
    var id = $(e.target).parent().find("[id]")[0].id;
    var cardHeader = $("#" + id);
    var parentItem = cardHeader.closest('.card');
    var win = $(window);
    var viewport = {
      top : win.scrollTop(),
    };
    var bounds = parentItem.offset();
    var itemHeight = parentItem.outerHeight();
    if (itemHeight > win.height() || (viewport.top+(win.height()/2)) < bounds.top || bounds.top < viewport.top) {
      var $navOffset = $offsetStickyNav;
      var $targetTop = $(parentItem).offset().top;
      if ($targetTop >= $offsetStickyNav) {
        $navOffset = $offsetStickyNavScrolled;
      }
      $('html, body').animate({
        scrollTop: ($(parentItem).offset().top - $navOffset)
      }, 800);
    }
  });
  
  // ##############################################
	// ################ Page Scroll #################
	// ##############################################

  var hash = window.location.hash;
  if (hash.length) {
    $('body, html').scrollTop(0);
    $('body').imagesLoaded(function() {
      if ($(hash).offset()) {
        var $navOffset = $offsetStickyNav;
        var $targetTop = $(hash).offset().top;
        if ($targetTop >= $offsetStickyNav) {
          $navOffset = $offsetStickyNavScrolled;
        }
        setTimeout(function(){
          $('html,body').animate( { scrollTop:($targetTop - $navOffset)} , 800);
        }, 1000);        
      }
    });
  }
 

});


// WEBPACK FOOTER //
// ./js/parts/header.js